module.exports = __webpack_public_path__ + "static/sevastova-gray-57e15f7133147719a7b39cfd2efa1c75.png";